import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { forwardRef } from 'react';
import { VariantProps, cva } from 'cva';

export type CheckboxProps = Omit<
  RadixCheckbox.CheckboxProps,
  'asChild' | 'className' | 'style'
> &
  VariantProps<typeof checkbox>;

export type CheckboxRef = HTMLButtonElement;

const checkbox = cva({
  base: [
    'inline-flex items-center justify-center relative h-[0.875rem] w-[0.875rem] rounded-[0.25rem] border before:absolute before:inset-0 before:bg-gradient-to-b before:from-transparent shadow-sm'
  ],
  variants: {
    intent: {
      primary: [
        'bg-white text-white border-newGray-950/10 shadow-newGray-950/6 data-[state=checked]:bg-[#5DE3FF]',
        'before:to-newGray-950/[0.02]'
      ],
      secondary: [
        'bg-newGray-900 text-white border-newGray-950/10 shadow-newGray-950/25 shadow-sm border-white/20 data-[state=checked]:bg-[#FDE047]',
        'before:to-newGray-950/[0.02]'
      ]
    }
  }
});

export const Checkbox = forwardRef<CheckboxRef, CheckboxProps>((props, ref) => {
  const { intent = 'primary', key, ...rest } = props;
  const safeKey = typeof key === 'bigint' ? key.toString() : key;

  return (
    <RadixCheckbox.Root
      ref={ref}
      key={safeKey}
      className={checkbox({ intent })}
      {...rest}
    >
      <RadixCheckbox.Indicator className="">
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 4.75L3.25 7L7 1"
            stroke="#131316"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </RadixCheckbox.Indicator>
    </RadixCheckbox.Root>
  );
});

Checkbox.displayName = 'Checkbox';
